import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { getEtag } from '@rossum/api-client';
import { usePatchSchema } from '../../../../../business/schema/usePatchSchema';
import { SchemaWithEtag } from '../../../../../business/schema/useSchema';
import { notify } from '../../../../toaster';
import { updateSchemaThresholds } from '../../core/utils';

type UseUpdateSchemathresholdsProps = {
  queueSchema: SchemaWithEtag | undefined;
};
export const useUpdateSchemaThresholds = ({
  queueSchema,
}: UseUpdateSchemathresholdsProps) => {
  const intl = useIntl();
  const { mutate: patchSchema, isLoading } = usePatchSchema({
    etag: queueSchema ? getEtag(queueSchema) : undefined,
  });

  const handleUpdateSchemaThresholds = useCallback(
    ({
      targetStateThresholdsMap,
      onSuccess,
    }: {
      targetStateThresholdsMap: Record<string, number | null>;
      onSuccess: () => void;
    }) => {
      const { id, url, content } = queueSchema ?? {};

      if (!content || !id || !url) {
        return;
      }

      const updatedSchemaContent = updateSchemaThresholds(
        content,
        targetStateThresholdsMap
      );

      patchSchema(
        {
          id,
          payload: {
            url,
            content: updatedSchemaContent,
          },
        },
        {
          onSuccess,
          onError: () => {
            notify.error({
              title: intl.formatMessage({
                id: 'containers.settings.queues.queue.automation.optimizeDrawer.save.error',
              }),
            });
          },
        }
      );
    },
    [intl, patchSchema, queueSchema]
  );

  return { handleUpdateSchemaThresholds, isLoading };
};
